import React from 'react';
import { useSelector } from 'react-redux';
import { Category, ICategoryProp } from '../components/Category';
import { Checkbox, ICheckbox } from '../components/Checkbox';
import { IOnOffProp, OnOff } from '../components/OnOff';
import { IRadioSelect, RadioSelect } from '../components/RadioSelect';
import { IRangeSliderProp, RangeSlider } from '../components/RangeSlider';
import { RootState, store } from '../store';
import { FilterWrapTempl } from './FilterWrapTempl';

export const FilterWrapLm = () => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const config = store.getState().main.config;

    const classCheckProp: ICheckbox = {
        l10n: l10n,
        config: config,
        title: l10n['common.class'],
        resetObj: { page: '1' },
        watch: 'class',
        cls: 'class',
        path: `/${config.service}/v2.0/game/character/class`,
        ga360str: '시세_조건검색_클래스_클릭',
        submitCallback: (_d) => {},
    };

    const gradeCheckProp: ICheckbox = {
        l10n: l10n,
        config: config,
        title: l10n['common.grade'],
        resetObj: { page: '1' },
        watch: 'grade',
        cls: 'grade',
        path: `/${config.service}/v2.0/game/item/grade`,
        ga360str: '시세_조건검색_등급_클릭',
        submitCallback: (_d) => {},
    };

    const rangeSliderProp: IRangeSliderProp = {
        watch1: 'enchantfrom',
        watch2: 'enchantto',
        l10n: l10n,
        min: 0,
        max: 11,
        step: 1,
        ga360str: '시세_조건검색_강화단계_클릭',
        submitCallback: (val: { min: number; max: number }) => {},
    };

    const blessProp: IRadioSelect = {
        l10n: l10n,
        config: config,
        title: l10n['noti.blessed'],
        resetObj: { page: '1' },
        watch: 'bless',
        cls: 'bless',
        path: `/${config.service}/v2.0/game/item/bless`,
        ga360str: '시세_조건검색_축복_클릭',
        submitCallback: (_d) => {},
    };

    const onoffProp: IOnOffProp = {
        l10n: l10n,
        watch: 'sale',
        resetObj: { page: '1' },
        title: l10n['price.checksale'],
        description: `${l10n['common.showcurrentitems']}`,
        ga360str: '시세_조건검색_판매여부_클릭',
        submitCallback: (_d) => {},
        initVal: 'true',
    };

    const categoryProp: ICategoryProp = {
        l10n: l10n,
        config: config,
        title: l10n['common.category'],
        watchD1: 'category1',
        watchD2: 'category2',
        path: `/${config.service}/v2.0/game/market/category`,
        ga360str: '시세_조건검색_카테고리_클릭',
        submitCallback: (d1, d2) => {},
    };

    const refObj = {
        class: '',
        grade: '',
        sale: 'true',
        category1: '',
        category2: '',
        enchantfrom: '',
        enchantto: '',
        bless: '',
        page: '1',
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            <Checkbox props={classCheckProp} />
            <Checkbox props={gradeCheckProp} />
            <RangeSlider props={rangeSliderProp} />
            <RadioSelect props={blessProp} />
            <OnOff props={onoffProp} />
            <Category props={categoryProp} />
        </FilterWrapTempl>
    );
};
